import { render } from "./Playground.vue?vue&type=template&id=6a22f33e&scoped=true"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"

import "./Playground.vue?vue&type=style&index=0&id=6a22f33e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a22f33e"]])

export default __exports__